module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"return-to-module-selection":"Retour à la sélection des modules"}}')
  delete Component.options._Ctor
}
